(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD
    define(['torso/modules/Collection', './CssVariableModel', 'app/urls'], factory);
  } else if (typeof exports === 'object') {
    // Node, CommonJS-like
    module.exports = factory(require('backbone-torso/modules/Collection'), require('./CssVariableModel'), require('./../../urls'));
  } else {
    throw 'Only AMD and CommonJS imports are supported.';
  }
}(this, function (TorsoCollection, CssVariableModel, urls) {
  'use strict';

  /**
   * @class cssVariableCollection
   * @static
   * @extends Torso.Collection
   */
  return new (TorsoCollection.extend({
    model: CssVariableModel,
    url: urls.cssVariableExtService,
    fetchHttpAction: 'POST'
  }))();
}));
